import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import DataHistorian from "../../AllEquipments/CommonFeatures/AssetManagementTab";

const SUB_TABS = [
  {
    label: "Digital Twin",
    panel: () => <div>Not Implemented</div>,
  },
  {
    label: "Data Historian",
    panel: () => (
      <Box pt={2}>
        <DataHistorian />
      </Box>
    ),
  },
];

export default function Digital3dModelingTab() {
  const [value, setValue] = useState(0);

  return (
    <Box flex={1}>
      <Tabs value={value} onChange={(_, v) => setValue(v)}>
        {SUB_TABS.map((t) => (
          <Tab
            key={t.label}
            label={t.label}
            sx={{
              minWidth: 180,
              maxWidth: 280,
              whiteSpace: "normal",
              textAlign: "center",
              py: 1,
            }}
          />
        ))}
      </Tabs>
      <Box>{SUB_TABS[value].panel()}</Box>
    </Box>
  );
}
